module.exports = __webpack_public_path__ + "static/media/info-card-1.6fcf387b.png";